import { Method } from 'axios';
import { Executable } from '../executable';
import { BambuBrandAttribute } from '../interfaces';

/**
 * The UpdateBrandAttribute used by the constructor of Update Brand Attribute
 */
export class UpdateBrandAttribute
  extends Executable<BambuBrandAttribute>
  implements Partial<BambuBrandAttribute>
{
  public brandAttributeId?: number;

  public brandId?: number;

  public name?: string;

  public description?: string;

  public required?: boolean;

  public unique_key?: boolean;

  public encrypted?: boolean;

  public searchable?: boolean;

  public dataType?: string;

  public getMethod(): Method {
    return 'patch';
  }

  public getResponse(apiResponse: any): BambuBrandAttribute {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.brandAttributeId) throw new Error('brandAttributeId is required');
    return `/${this.brandId}/attributes/${this.brandAttributeId}`;
  }

  constructor(
    input?: Partial<BambuBrandAttribute> & {
      brandAttributeId: number;
      brandId: number;
      name: string;
    }
  ) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): Partial<BambuBrandAttribute> & { brandId: number; name: string } {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.name) throw new Error('name is required');
    return {
      name: this.name,
      brandId: this.brandId,
      description: this.description,
      required: this.required,
      encrypted: this.encrypted,
      searchable: this.searchable,
      dataType: this.dataType,
      unique_key: this.unique_key,
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
